import { useEffect, useRef } from "react";
import { guaranteeContent } from "@/mocks/services";

export default function Guarantee() {
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = cardsRef.current?.children;
    if (cards) {
      Array.from(cards).forEach((card, index) => {
        card.classList.add("opacity-0", "translate-y-8", "transition-all", "duration-700");
        (card as HTMLElement).style.transitionDelay = `${index * 100}ms`;
        observer.observe(card);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="guarantee" className="py-20 md:py-28 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block bg-brand-50 text-brand-700 px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-brand-200">
              Garancija i podrška
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-dark-900 mb-4">
              Vaš miran san je
              <br />
              <span className="text-brand-500">naša garancija</span>
            </h2>
            <p className="text-dark-400 text-lg max-w-2xl mx-auto">
              Uz svaki sistem dobijate kompletan paket podrške i garancije
            </p>
          </div>

          <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
            {guaranteeContent.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-5 p-6 md:p-8 rounded-2xl bg-dark-50 border border-dark-100 hover:border-brand-200 transition-all group"
              >
                <div className="w-14 h-14 flex items-center justify-center flex-shrink-0 bg-brand-50 rounded-2xl group-hover:bg-brand-500 transition-all">
                  <i className={`${item.icon} text-2xl text-brand-500 group-hover:text-white transition-all`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-dark-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-dark-400 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}